
import QRCodeGenerator from "../qrcode/QRCodeGenerator";
import { Box, useTheme, Card, Typography, Divider, Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import qrcode from 'qrcode';
import { tokens } from "../../../theme/theme";

const LabelReamPalletDetails = ({ qrCodeValue, ProductDetail }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

       const handleButtonClick = async (ream_pallet_number) => {
        let isvalid = true;

        const bundledet = ProductDetail.find(
            (detail) => detail.ream_pallet_number === ream_pallet_number
        );

        if (bundledet.ream_pallet_number === '') {
            isvalid = false;
        }

        if (isvalid === true) {
            const printWindow = window.open('', '_blank');
            try {
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(bundledet.ream_pallet_number);
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', bundledet.ream_pallet_number);
                }

                let grossweight = bundledet.ream_pallet_gross_weight;

                // Write HTML content to the print window
                printWindow.document.write(`

                     <html>
                        <head>
                             
                        <style>
                            @page {
                                size: A4;
                                margin: 5mm;
                            }

                            body {
                                margin: 0;
                                padding: 5px;
                                font-family: Arial, sans-serif;
                                background-color: #f4f4f4;
                                font-size: 60px; /* Base font size increased */
                            }

                            .container {
                                display: flex;
                                align-items: flex-start;
                                justify-content: flex-start;
                                padding: 10px;
                                background-color: white;
                                width: 100%;
                                box-sizing: border-box;
                                margin-top: 2cm;
                            }

                            .bundle-details {
                                flex: 1;
                                margin-left: 10px;
                            }

                            .bundle-details h5 {
                                margin: 0;
                                font-size: 30px; /* Even bigger heading */
                                font-weight: bold;
                            }

                            .details-table {
                                display: grid;
                                grid-template-columns: 370px auto; /* Wider label column */
                                gap: 0;
                                margin-top: 12px;
                                border: 2px solid #000; /* Thicker outer border */
                                width: 100%;
                                box-sizing: border-box;
                            }

                            .details-table > div {
                                font-size:30px; /* Increased font size for all cells */
                                border: 1px solid #000;
                                padding: 12px 14px; /* More padding for print clarity */
                                box-sizing: border-box;
                                word-break: break-word;
                            }

                            .details-table .label {
                                font-weight: bold;
                                background-color: #eaeaea;
                               
                            }

                            @media print {
                                body {
                                    background-color: white;
                                }

                                .details-table .label {
                                    background-color: #eaeaea !important;
                                    -webkit-print-color-adjust: exact;
                                    print-color-adjust: exact;
                                }
                            }
                        </style>     
                        
                         </head>
                        <body>
                            <div class="container">
                                <div class="bundle-details">
                                    <div class="details-table">
                                        <div class="label">PRODUCT</div> <div>: ${bundledet.item_code}</div>   
                                        <div class="label">PACKED DATE</div><div>: ${bundledet.shift_date}</div> 
                                        <div class="label">LOT NO</div><div>: ${bundledet.pr_number || '0'}</div>  
                                        <div class="label">GSM</div><div>: ${bundledet.gsm || ''}</div>
                                        <div class="label">SIZE</div><div>: ${bundledet.size || ''}</div> 
                                        <div class="label">NO OF REAM / SHEET</div><div> : ${bundledet.no_of_reams || 0} / ${bundledet.sheets_in_reams || 0}</div>                                         
                                        <div class="label">NET WEIGHT (KG)</div><div>: ${bundledet.ream_pallet_weight || 0}</div>  
                                        <div class="label">GROSS WEIGHT (KG)</div><div>: ${grossweight || 0}</div>     
                                        <div class="label">PALLET NO-------</div><div>: ${bundledet.ream_pallet_number}</div>                   
                                                                     
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        </body>
                        </html>

                `);


            } catch (error) {
                console.error('Error handling button click:', error);
            }
        }
    };


    const handleButtonClickNew = async (ream_pallet_number) => {
        let isvalid = true;

        const bundledet = ProductDetail.find(
            (detail) => detail.ream_pallet_number === ream_pallet_number
        );

        if (bundledet.ream_pallet_number === '') {
            isvalid = false;
        }

        if (isvalid === true) {
            const printWindow = window.open('', '_blank');
            try {
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(bundledet.ream_pallet_number);
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', bundledet.ream_pallet_number);
                }

                let grossweight = bundledet.ream_pallet_gross_weight;

                // Write HTML content to the print window
                printWindow.document.write(`
                    <html>
                        <head>
                            <style>
                                @page {
                                    size: 206mm 306mm;
                                    margin: 3mm;
                                }

                                body {
                                    margin: 0;
                                    padding: 0;
                                    font-family: Arial, sans-serif;
                                    background-color: white;
                                }

                                .container {
                                    width: 200mm;
                                    height: 300mm;
                                    box-sizing: border-box;
                                    background-color: white;
                                    border: 2px solid #000;
                                    display: flex;
                                    flex-direction: column;
                                    overflow: hidden;
                                }

                                /* ── Header space (client will paste their logo here) ── */
                                .header-space {
                                    height: 92mm;
                                    min-height: 92mm;
                                    flex-shrink: 0;
                                    border-bottom: 2px solid #000;
                                    background-color: white;
                                }

                                /* ── Details table ── */
                                .details-table {
                                    display: grid;
                                    grid-template-columns: 42% 58%;
                                    grid-template-rows: 1fr 1fr 1fr 2.5fr 1fr 1fr 1fr 1fr 1fr 1fr;
                                    min-height: 0;
                                    gap: 0;
                                    flex: 1;
                                    width: 100%;
                                    box-sizing: border-box;
                                    background-color: white;
                                    overflow: hidden;
                                }

                                .details-table > div {
                                    font-size: 30px;
                                    font-family: Arial, sans-serif;
                                    border: 1px solid #000;
                                    padding: 4px 10px;
                                    box-sizing: border-box;
                                    word-break: break-word;
                                    background-color: white;
                                    display: flex;
                                    align-items: center;
                                }

                                .details-table .label {
                                    font-weight: bold;
                                    font-size: 27px;
                                    letter-spacing: 0.3px;
                                    background-color: white;
                                }

                                .details-table .value {
                                    font-size: 32px;
                                }

                                @media print {
                                    body { background-color: white; }

                                    .container {
                                        border: 2px solid #000 !important;
                                        -webkit-print-color-adjust: exact;
                                        print-color-adjust: exact;
                                    }

                                    .details-table > div,
                                    .details-table .label {
                                        background-color: white !important;
                                        -webkit-print-color-adjust: exact;
                                        print-color-adjust: exact;
                                    }
                                }
                            </style>
                        </head>
                        <body>
                            <div class="container">

                                <!-- ── Empty header space for client logo ── -->
                                <div class="header-space"></div>

                                <!-- ── Details table ── -->
                                <div class="details-table">
                                    <div class="label">PRODUCT--------------</div><div class="value">${bundledet.item_code}</div>
                                    <div class="label">PACKED DATE</div><div class="value">${bundledet.shift_date}</div>
                                    <div class="label">LOT NO</div><div class="value">${bundledet.pr_number || '0'}</div>
                                    <div class="label" style="flex-direction:column;align-items:flex-start;justify-content:center;gap:6px;"><span>PALLET NO.</span><img src="${qrDataUrl}" alt="QR Code" style="width:110px;height:110px;display:block;"/></div><div class="value" style="font-size:54px;font-weight:bold;line-height:1.1;">${bundledet.ream_pallet_number}</div>
                                    <div class="label">SIZE (CM)</div><div class="value">${bundledet.size || ''}</div>
                                    <div class="label">GSM</div><div class="value">${bundledet.gsm || ''}</div>
                                    <div class="label">NO OF REAM / SHEET</div><div class="value">${bundledet.no_of_reams || 0} / ${bundledet.sheets_in_reams || 0}</div>
                                    <div class="label">NET WEIGHT (KG)</div><div class="value">${bundledet.ream_pallet_weight || 0}</div>
                                    <div class="label">GROSS WEIGHT (KG)</div><div class="value">${grossweight || 0}</div>
                                    <div class="label" style="grid-column:span 2;justify-content:center;font-size:32px;font-weight:bold;letter-spacing:2px;">MADE IN INDIA</div>
                                </div>

                            </div>
                        </body>
                    </html>
                `);

            } catch (error) {
                console.error('Error handling button click:', error);
            }
        }
    };
    //<div class="label">FINISHER NO</div><div>:${bundledet.fno} </div>      
    // ${bundledet.grain || ''}
    // <h5>REAM PALLET DETAILS</h5> old format by thiravidam coder
    //  <hr/>

    //     <html>
    // <head>
    //     <title>Printed Report</title>
    //     <style>
    //         @page {
    //             size: A4;
    //             margin: 20mm;
    //         }

    //         body {
    //             margin: 0;
    //             padding: 20px;
    //             font-family: Arial, sans-serif;
    //             background-color: #f4f4f4;
    //             font-size: 18px; /* Increased base font size */
    //         }

    //         .container {
    //             display: flex;
    //             align-items: flex-start;
    //             justify-content: flex-start;
    //             padding: 10px;
    //             background-color: white;
    //             width: 100%;
    //             max-width: 100%;
    //             box-sizing: border-box;
    //         }

    //         .qr-code {
    //             width: 150px;
    //         }

    //         .bundle-details {
    //             flex: 1;
    //             margin-left: 20px;
    //         }

    //         .bundle-details h5 {
    //             margin: 0;
    //             font-size: 20px;
    //             font-weight: bold;
    //         }

    //         .details-table {
    //             display: grid;
    //             grid-template-columns: 220px auto; /* wider label column for print */
    //             gap: 0;
    //             margin-top: 10px;
    //             border: 1px solid #000;
    //             width: 100%; /* Full width for print compatibility */
    //             box-sizing: border-box;
    //         }

    //         .details-table > div {
    //             font-size: 18px; /* increased font */
    //             border: 1px solid #000;
    //             padding: 10px;
    //             box-sizing: border-box;
    //             word-break: break-word;
    //         }

    //         .details-table .label {
    //             font-weight: bold;
    //             background-color: #f0f0f0;
    //         }

    //         .bundle-details hr {
    //             margin: 10px 0;
    //             border: 1px solid #ccc;
    //         }

    //         /* Optional: remove background color when printing */
    //         @media print {
    //             body {
    //                 background-color: white;
    //             }

    //             .details-table .label {
    //                 background-color: #eee !important;
    //                 -webkit-print-color-adjust: exact;
    //                 print-color-adjust: exact;
    //             }
    //         }
    //     </style>
    // </head>
    // <body>
    //     <div class="container">
    //         <div class="bundle-details">
    //             <div class="details-table">
    //                 <div class="label">DATE / SHIFT</div><div>: ${bundledet.shift_date} / ${bundledet.shift_code}</div>  
    //                 <div class="label">QUALITY</div><div>: ${bundledet.item_code}</div>   
    //                 <div class="label">REEL NO</div><div>: ${bundledet.cr_number || '0'}</div>  
    //                 <div class="label">REAM PALLET NO</div><div>: ${bundledet.ream_pallet_number}</div>  
    //                 <div class="label">REAM PALLET WT (KG)</div><div>: ${bundledet.ream_pallet_weight || 0}</div>     
    //                 <div class="label">REAMS/ REAM PALLET</div><div>: ${bundledet.no_of_reams || 0}</div>                       
    //                 <div class="label">GRAIN</div><div>: ${bundledet.grain || ''}</div>
    //                 <div class="label">MA NO</div><div>: ${bundledet.lot_no || ''}</div>
    //                 <div class="label">SO NO</div><div>: ${bundledet.indent_no || ''}</div>
    //                 <div class="label">CUSTOMER</div><div>: ${bundledet.customer_name || ''}</div>
    //                 <div class="label">SUPPLIER</div><div>: ${bundledet.supplier_name || ''}</div>
    //                 <div class="label">GSM</div><div>: ${bundledet.gsm || ''}</div>
    //                 <div class="label">SIZE</div><div>: ${bundledet.size || ''}</div> 
    //             </div>
    //         </div>
    //     </div>
    // </body>
    // </html>


    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };

    return (
        <>



            {ProductDetail.map((detail, index) => (
                <>
                    <Card sx={{ backgroundColor: "transparent", m: 2, padding: 1 }} >
                        <Box mb={1}>
                            <Typography variant="h5" textAlign="center">{t('prod_reampallet.ream_pallet_details')}</Typography>
                        </Box>
                        <Divider sx={{ marginBottom: "10px" }} />

                        <Grid container spacing={0} justifyContent="space-between" alignItems="center">

                            <Grid item xs={12} lg={8}>
                                <Grid container spacing={0}>

                                    {/* M.O No */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">PRODUCT:</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">{detail.item_code}</Typography>
                                    </Grid>

                                    {/* Date and Shift */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">{`PACKED DATE:`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={7}>
                                        <Typography variant="h7">{`${detail.shift_date || ''}`}</Typography>
                                    </Grid>

                                    {/* MA NO : */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">LOT NO :</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">{detail.pr_number}</Typography>
                                    </Grid>

                                    {/* GSM */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">{`GSM:`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={7}>
                                        <Typography variant="h7">{`${detail.gsm || ''}`}</Typography>
                                    </Grid>

                                    {/* Size */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">{`Size:`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={7}>
                                        <Typography variant="h7">{`${detail.size || ''}`}</Typography>
                                    </Grid>

                                    {/* No. Set */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">NO OF REAMS / SHEET :</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={7}>
                                        <Typography variant="h7">{detail.no_of_reams}/{detail.sheets_in_reams}</Typography>
                                    </Grid>

                                    {/* Net weight */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">NET WEIGHT (KG) :</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={7}>
                                        <Typography variant="h7">{detail.ream_pallet_weight}</Typography>
                                    </Grid>

                                    {/* Gross weight */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">GROSS WEIGHT (KG) :</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={7}>
                                        <Typography variant="h7">{detail.ream_pallet_gross_weight}</Typography>
                                    </Grid>

                                    {/* Quantity */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">PALLET NO :</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">{detail.ream_pallet_number}</Typography>
                                    </Grid>


                                    {/* M.A No */}
                                    {/* <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">FINISHER NO :</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">{detail.fno}</Typography>
                                    </Grid>                               */}

                                </Grid>
                            </Grid>

                            {/* QR Code */}
                            <Grid item xs={12} lg={4} textAlign="center">
                                <Typography variant="h7">{detail.ream_pallet_number}</Typography>
                                <QRCodeGenerator value={detail.ream_pallet_number} />
                            </Grid>
                        </Grid>

                        <Divider sx={{ marginTop: "5px", marginBottom: "5px" }} />
                        <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                            <Button size="small" sx={{ textTransform: "none" ,mr:1 }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.ream_pallet_number)}>Print</Button>

                             <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClickNew(detail.ream_pallet_number)}>Print New QR</Button>
                        </Box>
                    </Card>
                </>
            ))}
        </>
    );

}
export default LabelReamPalletDetails;



//  {ProductDetail.map((detail, index) => (
//                 <>
//                     <Card sx={{ backgroundColor: "transparent", m: 2, padding: 1 }} >
//                         <Box mb={1}>
//                             <Typography variant="h5" textAlign="center">{t('prod_reampallet.ream_pallet_details')}</Typography>
//                         </Box>
//                         <Divider sx={{ marginBottom: "10px" }} />

//                         <Grid container spacing={0} justifyContent="space-between" alignItems="center">
//                             <Grid item xs={12} lg={8}>
//                                 <Grid container spacing={0}>
//                                     {/* Date and Shift */}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{`DATE / SHIFT :`}</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={7}>
//                                         <Typography variant="h7">{`${detail.shift_date || ''} / ${detail.shift_code || ''}`}</Typography>
//                                     </Grid>

//                                     {/* M.O No */}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">QUALITY :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.item_code}</Typography>
//                                     </Grid>

//                                     {/* M.A No */}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">REEL NO :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.cr_number}</Typography>
//                                     </Grid>

//                                     {/* Quantity */}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">REAM PALLET NO :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.ream_pallet_number}</Typography>
//                                     </Grid>

//                                     {/* GSM */}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">REAM PALLET.WT (KG) :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={7}>
//                                         <Typography variant="h7">{detail.ream_pallet_weight}</Typography>
//                                     </Grid>

//                                     {/* No. Set */}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">REAMS/REAM PALLET :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.no_of_reams}</Typography>
//                                     </Grid>

//                                     {/* ID / OD */}
//                                     {/* <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">REAM.WT (KG) :</Typography>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">{detail.ream_weight}</Typography>
//                                 </Grid> */}

//                                     {/* TOTAL SHEETS */}
//                                     {/* <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">TOTAL SHEETS :</Typography>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">{detail.sheets_in_bundle}</Typography>
//                                 </Grid> */}

//                                     {/* TOTAL SHEETS */}
//                                     {/* <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">SHEETS IN REAM:</Typography>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">{detail.sheets_in_reams || 0}</Typography>
//                                 </Grid> */}

//                                     {/* TOTAL SHEETS */}
//                                     {/* <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">ORDER TYPE:</Typography>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">{detail.sheets_in_reams || 0}</Typography>
//                                 </Grid> */}

//                                     {/* GRAIN : */}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">GRAIN :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.grain}</Typography>
//                                     </Grid>

//                                     {/* MODE OF PACKING */}
//                                     {/* <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">MODE OF PACKING :</Typography>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={3} lg={5}>
//                                     <Typography variant="h7">{detail.gsm}</Typography>
//                                 </Grid> */}

//                                     {/* MA NO : */}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">MA NO :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.lot_no}</Typography>
//                                     </Grid>

//                                     {/* SO NO :*/}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">SO NO :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.indent_no}</Typography>
//                                     </Grid>

//                                     {/* CUSTOMER :*/}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">CUSTOMER :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.customer_name}</Typography>
//                                     </Grid>

//                                     {/* SUPPLIER :*/}
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">SUPPLIER :</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6} md={3} lg={5}>
//                                         <Typography variant="h7">{detail.supplier_name}</Typography>
//                                     </Grid>

//                                 </Grid>
//                             </Grid>

//                             {/* QR Code */}
//                             <Grid item xs={12} lg={4} textAlign="center">
//                                 <Typography variant="h7">{detail.ream_pallet_number}</Typography>
//                                 <QRCodeGenerator value={detail.ream_pallet_number} />
//                             </Grid>
//                         </Grid>





//                         <Box>
//                             <Typography variant="h4">GSM: {detail.gsm}</Typography>
//                             <Typography variant="h4">SIZE :  {detail.size}</Typography>
//                         </Box>
//                         <Divider sx={{ marginTop: "5px", marginBottom: "5px" }} />
//                         <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
//                             <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.ream_pallet_number)}>Print</Button>
//                         </Box>
//                     </Card>
//                 </>
//             ))}